export default __webpack_public_path__ + "locales/sk/WebPlugins.json?hash=c205ff802aa7dee45fc07d58259c2843";